module.exports = __webpack_public_path__ + "img/qualitas-logo.dc51b08b.svg";